import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {HelperService} from "../services/helper.service";
import {DashboardService} from "../services/dashboard.service";

@Component({
  selector: 'app-qhse-information-modal',
  templateUrl: './qhse-information-modal.component.html',
  styleUrls: ['./qhse-information-modal.component.scss'],
  providers: [DashboardService, HelperService],
})
export class QhseInformationModalComponent implements OnInit {

  public profile: any = {};
  public companySystemID = this.helperService.getSelectedCompanyId();

  constructor(private dashboardService: DashboardService,
              private helperService: HelperService,
              public bsModalRef: BsModalRef) {
  }

  ngOnInit() {
    this.getCurrentCompanyData();
  }

  getCurrentCompanyData() {
    const that = this;
    that.dashboardService
      .getCurrentCompanyDetail()
      .get({
        'companySystemID': that.companySystemID,
      })
      .subscribe(resp => {
        that.profile = resp.data.data;
      }, (err) => {

      });
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

}



// WEBPACK FOOTER //
// /app/src/app/qhse-information-modal/qhse-information-modal.component.ts